// extracted by mini-css-extract-plugin
module.exports = {"Loader-wrapper":"loader_Loader-wrapper__2rGNw","loader":"loader_loader__2BoVf","Table":"loader_Table__cRr6i"};